<template>
  <div>
    <HMSimpleActionCard
      class="mb-3"
      :prefixIcon="['fas', 'fa-image']"
      v-for="file in modelValue"
      :key="file.id"
      :title="cleanedFileName(file.file_name)"
    >
      <template #actions>
        <i 
          class="c-coral ms-2 far fa-trash"
          @click="removeFile"
        ></i>
      </template>
    </HMSimpleActionCard>
    <HMFileUpload
      v-if="!modelValue.length || multiple"
      :modelValue="null"
      @update:modelValue="addFile"
      @uploading="status => this.$emit('uploading', status)"
      :studioURL="getStudioURL()"
    />
  </div>
</template>

<script lang="ts">
import { cleanedFileName } from '@/utils/utils';

export default {
  name: 'QuizUploadFile',
  props: {
    modelValue: {
      required: true,
      type: Array,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addFile(file) {
      const files = [...this.modelValue];
      files.push(file);
      console.log(files);
      this.$emit('update:modelValue', files);
    },
    removeFile(fileIndex) {
      const files = [...this.modelValue];
      files.splice(fileIndex, 1);
      this.$emit('update:modelValue', files);
    },
    getStudioURL() {
      return this.$studioURL;
    },
    cleanedFileName,
  },
};
</script>
